import { CeruleanButton } from 'components/Button'
import I18n from 'components/I18n'
import Money from 'components/Money'
import messages from 'lang'
import React from 'react'
import styled from 'styled-components'
import { color } from 'utils/styledHelper'

import { Header, ModalTitle, Wrapper } from '../../styles'

const Button = styled(CeruleanButton)`
  width: 100%;
`

const Description = styled.p`
  font-weight: 500;
  font-size: 1rem;
  line-height: 150%;
  color: ${color('body')};
`

type Props = {
  amount: string
  currency: string
  onBack: () => void
}
const FiatSuccess = ({ amount, currency, onBack }: Props) => (
  <Wrapper>
    <Header>
      <ModalTitle>
        <I18n data={messages.withdraw_title} />
      </ModalTitle>
    </Header>
    <Description>
      <I18n
        data={messages.withdrawal_success_fiat1}
        value={
          <b>
            <Money amount={amount} currency={currency} />
          </b>
        }
      />
    </Description>
    <footer>
      <Button onClick={onBack}>
        <I18n data={messages.button_ok} />
      </Button>
    </footer>
  </Wrapper>
)

export default FiatSuccess
